<template>
    <v-card :dark="isDark" style="height: 100%" class="package-card surface" :flat="isDark" :class="{'bordered': !isDark}">
        <div
            :style="imageStyle"
            class="package-cover e-link d-flex align-center justify-center"
            v-ripple
            @click="openAction"
        >
            <v-icon v-if="!pkg.image_url" size="48" color="white" style="opacity: 0.85">mdi-package-variant-closed</v-icon>
        </div>
        <div class="px-4 py-3">
            <div class="mb-1 details-text muted--text d-flex align-center flex-wrap">
                <span>باقة اشتراك</span>
                <span v-if="pkg.price != null && platform !== 'ios'" class="ms-1">
                    |
                    <b class="primary--text">{{ moneyFormat(pkg.price, true) }}</b>
                </span>
                <v-chip
                    v-if="statusChip"
                    label
                    small
                    dark
                    :color="statusChip.color"
                    class="ms-1"
                    style="height: 20px; padding: 0 6px;"
                >
                    <v-icon size="14" class="me-1">{{ statusChip.icon }}</v-icon>
                    <span>{{ statusChip.text }}</span>
                </v-chip>
            </div>
            <div class="package-title sm-title strong-text--text e-link" v-ripple @click="openAction">
                {{ pkg.name }}
            </div>
            <div v-if="pkg.current_month" class="mt-3 small-text d-flex align-center">
                <v-icon color="primary" small class="me-1">mdi-calendar-month</v-icon>
                <span>{{ pkg.current_month.name }}</span>
            </div>
            <div v-if="subjectsCount" class="mt-2 small-text d-flex align-center">
                <v-icon color="primary" small class="me-1">mdi-bookshelf</v-icon>
                {{ unitFormat(subjectsCount, 'مادة', 'مادتين', 'مواد') }}
            </div>
            <div class="mt-4">
                <v-btn
                    block
                    depressed
                    :color="actionBtn.color"
                    :disabled="actionBtn.disabled"
                    @click="openAction"
                >
                    <v-icon left>{{ actionBtn.icon }}</v-icon>
                    {{ actionBtn.text }}
                </v-btn>
            </div>
        </div>

        <package-dialog v-model="dialog" :pkg="pkg" :mode="dialogMode" @done="onDone" />
    </v-card>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import PackageDialog from '@/components/custom/package-dialog'

export default {
    props: {
        pkg: { type: Object, required: true },
    },
    components: { PackageDialog },
    data() {
        return {
            dialog: false,
            dialogMode: 'subscribe',
        }
    },
    computed: {
        ...GlobalComputed,
        subjectsCount() {
            return this.pkg.subjects ? this.pkg.subjects.length : 0
        },
        imageStyle() {
            const height = this.phoneOnly ? 200 : 170
            if (this.pkg.image_url) {
                return `background-image: url(${this.pkg.image_url}); height: ${height}px; background-size: cover; background-position: center; width: 100%`
            }
            return `height: ${height}px; width: 100%; background: linear-gradient(135deg, #00897B 0%, #004D40 100%)`
        },
        statusChip() {
            if (this.pkg.subscribed && this.pkg.renewal_required) {
                return { text: 'مطلوب تجديد', color: 'orange darken-2', icon: 'mdi-calendar-alert' }
            }
            if (this.pkg.subscribed) {
                return { text: 'مشترك', color: 'success', icon: 'mdi-check-circle-outline' }
            }
            return null
        },
        actionBtn() {
            if (this.pkg.subscribed && this.pkg.renewal_required) {
                return { text: 'تجديد الاشتراك', color: 'primary darken-1', icon: 'mdi-refresh', disabled: false }
            }
            if (this.pkg.subscribed) {
                return { text: 'مشترك', color: 'success', icon: 'mdi-check', disabled: true }
            }
            return { text: 'اشترك الآن', color: 'primary', icon: 'mdi-package-variant-closed', disabled: false }
        },
    },
    methods: {
        ...GlobalMethods,
        openAction() {
            if (this.pkg.subscribed && !this.pkg.renewal_required) {
                this.showMsg('أنت مشترك بالفعل في الباقة', 'grey lighten-3')
                return
            }
            this.dialogMode = this.pkg.subscribed && this.pkg.renewal_required ? 'renew' : 'subscribe'
            this.dialog = true
        },
        onDone() {
            this.$emit('updated')
        },
    },
}
</script>

<style lang="scss" scoped>
.package-card.v-card {
    border-radius: 6px !important;
    overflow: hidden;

    .package-cover {
        width: 100%;
    }

    .package-title {
        text-overflow: ellipsis !important;
        overflow: hidden !important;
        line-height: 1.4;
        font-size: 1.08rem;
        cursor: pointer;
        white-space: nowrap;
    }
}
</style>
